import { useState, useEffect, Fragment } from "react";
import { useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { editarBreadcrumb } from '../../actions/breadcrumb';

import FiltrosJovenes from './FiltrosJovenes';
import FiltrosEmpresas from './FiltrosEmpresas';

const Reportes = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Reportes',
            path: '/reportes'
        }
    ];

    const dispatch = useDispatch();

    const [jovenReporte, setJovenReporte] = useState(false);
    const [empresaReporte, setEmpresaReporte] = useState(false);
    const [reservacionReporte, setReservacionReporte] = useState(false);
    const [gimnasioReporte, setGimnasioReporte] = useState(false);
    const [solicitudReporte, setSolicitudReporte] = useState(false);
    const [eventoReporte, setEventoReporte] = useState(false);
    const [asesoriaReporte, setAsesoriaReporte] = useState(false);

    /* Buscar */
    const handleFiltrosJoven = (valor) => {
        setJovenReporte(valor);
    }

    const handleFiltrosEmpresa = (valor) => {
        setEmpresaReporte(valor);
    }

    const handleFiltrosReservacion = (valor) => {
        setReservacionReporte(valor);
    }

    const handleFiltrosGimnasio = (valor) => {
        setGimnasioReporte(valor);
    }

    const handleFiltrosSolicitud = (valor) => {
        setSolicitudReporte(valor);
    }

    const handleFiltrosEvento = (valor) => {
        setEventoReporte(valor);
    }

    const handleFiltrosAsesoria = (valor) => {
        setAsesoriaReporte(valor);
    }

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return(
        <Fragment>

            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .titulo {
                            color: #111F62;
                        }

                        .subtitulo {
                            margin: 0px;
                        }
                        
                        .buttonIcon {
                            padding: 20px;
                            font-size: 30px;
                            background-color: #111F62;
                            color: #FFFFFF;
                            border-radius: 10px;
                            margin-bottom: 15px;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <FiltrosJovenes jovenReporte={jovenReporte} reestablecerFiltros={() => handleFiltrosJoven(false)} />
            <FiltrosEmpresas empresaReporte={empresaReporte} reestablecerFiltros={() => handleFiltrosEmpresa(false)} />
                
            <div className="row">
                <div className="col-md-8 offset-md-2">
                    <div className="row d-flex align-items-center mb-3 mt-5">
                        <div className="col-md-8">
                            <h3>Reportes</h3>
                        </div>
                    </div>
                    <div className="row mb-3 mt-5">
                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosJoven(true)}>
                                <div className="card-body centrado_horizontal">
                                    <div className="card-title mb-0" id="certificaciones_financiero">
                                        <i className="buttonIcon fa-solid fa-money-bill-transfer" />
                                        <h5 className="titulo">Comisiones</h5>
                                        <p className="subtitulo">Reporte que permite visualizar el listado de las comisiones generadas por cada cita.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosEmpresa(true)}>
                                <div className="card-body centrado_horizontal">
                                    <div className="card-title mb-0" id="certificaciones_academico">
                                        <i className="buttonIcon fa-solid fa-money-check" />
                                        <h5 className="titulo">Membresias</h5>
                                        <p className="subtitulo">Reporte que permite visualizar el listado de las membresias adquiridas por los clientes.</p>
                                    </div>
                                </div>
                            </button>
                        </div>

                        <div className="col-md-6 my-2">
                            <button type="button" className="card bg-light w-100 card-style" onClick={() => handleFiltrosReservacion(true)}>
                                <div className="card-body centrado_horizontal">
                                    <div className="card-title mb-0" id="estudiantes">
                                        <i className="buttonIcon fa-solid fa-store" />
                                        <h5 className="titulo">Locatarios</h5>
                                        <p className="subtitulo">Reporte que permite visualizar el listado de las citas realizadas por cada locatario.</p>
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Reportes;